export default __webpack_public_path__ + "static/media/boxed-bg.ec8a9928.png";